import { HttpHeaders } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  Injector,
  OnInit,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '@app/shared/service/toast.service';
import { environment } from '@env/environment';
import { CommonUtilityService } from '@services/common-utility.service';
import { DalService } from '@upr-web-primer/dal';
import { MsGuestsService } from '@upr-web-primer/ms-guests';
import { NotificationService } from '@upr-web-primer/notification';
import { LocalStorageService } from '@upr-web-primer/storage';
import { UrlInfo, UrlInfoService } from '@upr-web-primer/url-info';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.scss'],
})
export class PaymentListComponent implements OnInit {
  urlInfo: UrlInfo;
  page: any;
  pageLabels: any;
  myAddresses: any;
  backLink: string;
  notRegister = false;
  register = false;
  paymentData: any;
  showPrimaryCard: any;
  showLoader = false;

  private route: ActivatedRoute;
  private commonUtilityService: CommonUtilityService;
  private urlInfoService: UrlInfoService;

  constructor(
    protected injector: Injector,
    private title: Title,
    public dal: DalService,
    public guestsService: MsGuestsService,
    public cdRef: ChangeDetectorRef,
    public cookieService: CookieService,
    private notification: NotificationService,
    @Inject('AppRoutes') private appRoutes: any,
    @Inject('GlobalDefaults') public globalDefault: any,
    @Inject('Ranges') public ranges: any,
    @Inject('RelativeUrls') private relativeUrls: any,
    @Inject('AppDefaults') public appDefault: any,
    public toastService: ToastService,
    @Inject('sourceKeys') public sourceKeys: any,
    private localStorage: LocalStorageService,
    @Inject('DefaultValues') public defaultValues: any
  ) {
    this.setDependencies();
    this.urlInfo = this.route.snapshot.data.urlInfo;
    this.page = this.route.snapshot.data.page;
    this.pageLabels = this.commonUtilityService.getResolvedPageData();
    this.title.setTitle(this.pageLabels?.['page.address']);
    this.backLink =
      this.urlInfoService.getUrlPrefix() + '/' + this.appRoutes.MY_PROFILE;
  }

  ngOnInit(): void {
    this.loadPaymentInfo();
  }

  private setDependencies(): void {
    this.route = this.injector.get(ActivatedRoute);
    this.commonUtilityService = this.injector.get(CommonUtilityService);
    this.urlInfoService = this.injector.get(UrlInfoService);
  }

  /**
   * addAddressInfo-It will navigate to Add_Address Page
   */

  addPaymentInfo(): void {
    this.commonUtilityService.changeRoute(this.appRoutes.ADD_PAYMENT_INFO);
  }

  /**
   * bacToAccInfo-It will go back to My_Profile Page
   */

  bacToAccInfo(): void {
    this.commonUtilityService.changeRoute(this.appRoutes.MY_PROFILE);
  }

  editPaymentInfo(index: any): void {
    this.showLoader = true;
    this.loadCurrentCardData(index.id);
  }

  loadPaymentInfo(): void {
    const guestId = this.guestsService.helper.getGuestId();
    const url = this.getRelativeUrls(
      this.relativeUrls.GET_PAYMENT_INFO,
      guestId
    );
    const headers = new HttpHeaders().append('guest-id', guestId);
    this.dal
      .httpRequest(url, this.appDefault.GET, guestId, headers)
      .then((response) => {
        this.paymentData = response;
        this.paymentData.sort((_a: any, _b: any) => {
          if (_a.is_primary > _b.is_primary) return -1;
          if (_a.is_primary < _b.is_primary) return 1;
          return 0;
        });
        this.paymentData.find((primaryCard: { is_primary: boolean }) => {
          if (primaryCard.is_primary) {
            this.showPrimaryCard = primaryCard;
          }
        });
        this.showLoader = false;
        this.cdRef.detectChanges();
      })
      .catch((error) => {
        this.showLoader = false;
        if (error.status == this.globalDefault.ERROR_401) {
          this.commonUtilityService.setUser();
          localStorage.clear();
          sessionStorage.clear();
          this.cookieService.deleteAll('/', environment.cookieSubDomain);
          const redirectUrl = this.commonUtilityService.getOidcRedirectionUrl();
          this.commonUtilityService.redirectToOidcAppEndSession(redirectUrl);
        } else {
          this.notification?.show(error?.error?.message);
          this.commonUtilityService.eventDDlTrigger(error?.error?.message);
        }
      });
  }

  public getRelativeUrls(url: string, guestId: string): string {
    return url.replace('{guest_id}', guestId);
  }

  numSequence(n: number): Array<number> {
    return Array(n);
  }

  deleteCard(userPaymentCardData: any): void {
    const guestId = this.guestsService.helper.getGuestId();
    const paymentCardId = userPaymentCardData?.id;
    const url = this.getRelativeUrlsLoad(
      this.relativeUrls.UPDATE_PAYMENT_INFO,
      guestId,
      paymentCardId
    );
    const xSourceId = this.commonUtilityService?.getSourceId(
      this.sourceKeys?.WEB_USH_CARD
    );
    const eTag = this.localStorage.getItem('WALLET-ETAG');
    const headers = new HttpHeaders()
      .append('If-Match', eTag)
      .append('x-source-id', xSourceId)
      .append('guest-id', guestId)
      .append('payment-card-id', paymentCardId);
    this.dal
      .httpRequest(url, this.appDefault.DELETE, {}, headers)
      .then(() => {
        this.toastService.show({
          text: this.pageLabels?.['paymentInfo.addSnack'],
          type: this.globalDefault?.SUCCESS,
        });
        this.loadPaymentInfo();
      })
      .catch((error) => {
        this.showLoader = false;
        if (error.status == this.globalDefault.ERROR_401) {
          this.commonUtilityService.setUser();
          localStorage.clear();
          sessionStorage.clear();
          this.cookieService.deleteAll('/', environment.cookieSubDomain);
          const redirectUrl = this.commonUtilityService.getOidcRedirectionUrl();
          this.commonUtilityService.redirectToOidcAppEndSession(redirectUrl);
        } else if (error.status == this.globalDefault.ERROR_400) {
          this.notification?.show(error?.error?.detail);
          this.commonUtilityService.eventDDlTrigger(error?.error?.detail);
        } else {
          this.notification?.show(error?.error?.message);
          this.commonUtilityService.eventDDlTrigger(error?.error?.message);
        }
      });
  }

  loadCurrentCardData(cardRefId: string): void {
    const guestId = this.guestsService.helper.getGuestId();
    const url = this.getRelativeUrlsLoad(
      this.relativeUrls.UPDATE_PAYMENT_INFO,
      guestId,
      cardRefId
    );
    const headers = new HttpHeaders()
      .append('guest-id', guestId)
      .append(
        'x-uniwebservice-apikey',
        this.defaultValues.UNIWebService_xApiKey
      )
      .append('payment-card-id', cardRefId);
    this.dal
      .httpRequest(url, this.appDefault.GET, guestId, headers)
      .then((response: any) => {
        if (response) {
          this.deleteCard(response);
        }
        this.showLoader = false;
      })
      .catch((error) => {
        this.showLoader = false;
        if (error.status == this.globalDefault.ERROR_401) {
          this.commonUtilityService.setUser();
          localStorage.clear();
          sessionStorage.clear();
          this.cookieService.deleteAll('/', environment.cookieSubDomain);
          const redirectUrl = this.commonUtilityService.getOidcRedirectionUrl();
          this.commonUtilityService.redirectToOidcAppEndSession(redirectUrl);
        } else {
          this.notification?.show(error?.error?.message);
          this.commonUtilityService.eventDDlTrigger(error?.error?.message);
        }
      });
  }

  public getRelativeUrlsLoad(
    url: string,
    guestId: string,
    paymentCardId: string
  ): string {
    url = url.replace('{guest_id}', guestId);
    return url.replace('{payment_card_id}', paymentCardId);
  }
}
